// @flow

/**
 * Export entities module.
 */

export * from 'core/entities/metatags';
export * from 'core/entities/pages';



// WEBPACK FOOTER //
// ../src/core/entities/index.js